<template>
  <div class="admin_home">
    <PayrollHeader />
    <div class="success">
      <div class="success__container">
        <div class="success__container--image">
          <img src="./../../../assets/style/images/sm-chat.svg" />
        </div>
        <span>Way to Go!</span>
        <p>
          Thank you for signing up with us. We have sent you an email containing your <b>password</b>. Please proceed with your account by logging in below.
        </p>
        <div class="success__container--btn">
          <routerLink to="/login">
            <div>Login</div>
          </routerLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PayrollHeader from "../../partials/payrollHeader";

export default {
  name: "OnboardSuccess",
  components: {
    PayrollHeader
  }
};
</script>
<style lang="scss" scoped>
.success {
  padding: 50px 10px;
  > .success__container {
    text-align: center;

    > .success__container--image {
      width: 50px;
      height: 50px;
      margin: 0 auto 20px auto;
    }

    > span {
      font-size: 30px;
      font-weight: 600;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.18;
      letter-spacing: normal;
      text-align: center;
      color: #000000;
    }

    > p {
      font-size: 16px;
      max-width: 600px;
      font-weight: 600;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.9;
      letter-spacing: normal;
      text-align: center;
      color: #000000;
      margin: 20px auto;
    }

    > .success__container--btn {
      width: 200px;
      margin: auto;
      border-radius: 5px;
      background-color: #5099de;
      overflow: hidden;

      > a {
        color: #ffffff;
        text-decoration: none;

        > div {
          width: 100%;
          padding: 12px 0;
          font-size: 12px;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.22;
          letter-spacing: normal;
          text-align: center;
          color: #ffffff;
        }
      }
    }
  }
}
</style>
